import React from 'react';
import { trackingFavoritesItemClick } from './tracking';

import { NoFavorites } from '../NoFavorites';
import { EEntityTypes } from '../../repositories/favorites/v1/web-get-user-favorites';
import { IFavoriteEntityForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { FavoriteItem } from '../FavoriteItem';

interface IFavoritesListProps {
  canLoadMore: boolean;
  favoriteEntities: IFavoriteEntityForDesktopSchema[];
  entityTypes: EEntityTypes.Newbuilding | null;
  updateFavoritesList(length: number): void;
}

export const FavoritesList: React.FC<IFavoritesListProps> = ({
  canLoadMore,
  favoriteEntities,
  entityTypes,
  updateFavoritesList,
}) => {
  const updateFavorites = () => {
    const block = document.querySelector('#c-favorites-wrapper');
    let scrollHeight = block ? block.scrollHeight : 0;
    let scrollTop = block ? block.scrollTop : 0;
    let blockHeigh = block ? (block as HTMLElement).offsetHeight : 0;
    const entityLength = favoriteEntities.length;

    if (canLoadMore && scrollHeight === scrollTop + blockHeigh) {
      updateFavoritesList(entityLength + 10);
    }
  };

  return (
    <div
      id="c-favorites-wrapper"
      className="c-header-modal__notification-wrapper c-header-modal__notification-wrapper--favorites"
      onScroll={updateFavorites}
    >
      {favoriteEntities.length ? (
        favoriteEntities.map(entity => (
          <FavoriteItem
            key={entity.entityId}
            fullUrl={entity.fullUrl}
            title={entity.title}
            price={entity.bargainTerms.priceText}
            photoFullUrl={entity.photoFullUrl}
            geo={entity.geo}
            onClick={trackingFavoritesItemClick}
          />
        ))
      ) : (
        <NoFavorites isNewbuilding={entityTypes === EEntityTypes.Newbuilding} />
      )}
    </div>
  );
};
